import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Validation } from '../../common/validation/validation';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PageButtonComponent } from '../page-button/page-button.component';

@Component({
  selector: 'app-log-out',
  imports: [ReactiveFormsModule,PageButtonComponent],
  templateUrl: './log-out.component.html',
  styleUrl: './log-out.component.css'
})
export class LogOutComponent implements OnInit {
forgetPasswordForm!: FormGroup;
  Validation = Validation
  @Output() modalDismiss = new EventEmitter<void>();

  constructor(public fb: FormBuilder) { }
  ngOnInit(): void {
    this.forgetPasswordForm = this.fb.group({
      email: ['', this.Validation.clinic.EMAIL.pattren]
    });
  }
  onSubmit(): void {
    if (this.forgetPasswordForm.valid) {
    }
  }
  closeModal() {
    this.modalDismiss.emit();
  }
}
